import React from 'react';
import NavBar from './components/NavBar';
import OpenSource from './components/atlantico/openSource/OpenSource';

function OpenSourcePage() {
    return (
        <div>
            <NavBar />
            <OpenSource />
        </div>
    );
}

export default OpenSourcePage;
